var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 2.49992H19.1667C19.3877 2.49992 19.5996 2.41212 19.7559 2.25584C19.9122 2.09956 20 1.8876 20 1.66659C20 1.44557 19.9122 1.23361 19.7559 1.07733C19.5996 0.921049 19.3877 0.833252 19.1667 0.833252H5.83333C5.61232 0.833252 5.40036 0.921049 5.24408 1.07733C5.0878 1.23361 5 1.44557 5 1.66659C5 1.8876 5.0878 2.09956 5.24408 2.25584C5.40036 2.41212 5.61232 2.49992 5.83333 2.49992Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 6.66675H5.83333C5.61232 6.66675 5.40036 6.75455 5.24408 6.91083C5.0878 7.06711 5 7.27907 5 7.50008C5 7.7211 5.0878 7.93306 5.24408 8.08934C5.40036 8.24562 5.61232 8.33341 5.83333 8.33341H19.1667C19.3877 8.33341 19.5996 8.24562 19.7559 8.08934C19.9122 7.93306 20 7.7211 20 7.50008C20 7.27907 19.9122 7.06711 19.7559 6.91083C19.5996 6.75455 19.3877 6.66675 19.1667 6.66675Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 12.5H5.83333C5.61232 12.5 5.40036 12.5878 5.24408 12.7441C5.0878 12.9004 5 13.1123 5 13.3333C5 13.5543 5.0878 13.7663 5.24408 13.9226C5.40036 14.0789 5.61232 14.1667 5.83333 14.1667H19.1667C19.3877 14.1667 19.5996 14.0789 19.7559 13.9226C19.9122 13.7663 20 13.5543 20 13.3333C20 13.1123 19.9122 12.9004 19.7559 12.7441C19.5996 12.5878 19.3877 12.5 19.1667 12.5Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 3.33333C2.58714 3.33333 3.33333 2.58714 3.33333 1.66667C3.33333 0.746192 2.58714 0 1.66667 0C0.746192 0 0 0.746192 0 1.66667C0 2.58714 0.746192 3.33333 1.66667 3.33333Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 9.16659C2.58714 9.16659 3.33333 8.42039 3.33333 7.49992C3.33333 6.57944 2.58714 5.83325 1.66667 5.83325C0.746192 5.83325 0 6.57944 0 7.49992C0 8.42039 0.746192 9.16659 1.66667 9.16659Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 15.0001C2.58714 15.0001 3.33333 14.2539 3.33333 13.3334C3.33333 12.4129 2.58714 11.6667 1.66667 11.6667C0.746192 11.6667 0 12.4129 0 13.3334C0 14.2539 0.746192 15.0001 1.66667 15.0001Z",
    fill: "#929292"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.eb1ab85445b3b58809a13f6622f1ad05.svg";
export { ForwardRef as ReactComponent };